export default "__VITE_ASSET__CwO2XZ9P__"